export default __webpack_public_path__ + "static/media/wow.9a4bafa6.svg";